import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import {injectIntl} from "@irati/utils/lang"
import {Card, Hr} from "@irati/ui/src/Layout"
import id from "@irati/utils/id"
import {minWidthMedia} from "@irati/ui/src/global/media"
import {twoPxShadow} from "@irati/ui/src/global/elevation"
import padding from "@irati/ui/src/global/padding"
import {H3} from "@irati/ui/src/Headings"
import Expand from "@irati/ui/src/Expander"

import {Image} from "../../../ui/Image"
import ScheduleDescription from "./ScheduleDescription"
import {StatusPillBadge} from "../../StatusPillBadge"
import EmployeeEngagement from "../../../../images/aoiImages/EmployeeEngagement.svg"
import CustomSurvey from "../../../../images/aoiImages/CustomSurvey.svg"
import ViewSurveyCycleIcon from "../../../../images/survey/viewSurveyCycle.svg"
import {SurveyList} from "../../Survey"
import isCycleCustom from "../../../helpers/cycle/isCycleCustom"


const CardWrapper = styled.div`
  padding-bottom: ${padding.base};
  &:last-child {
    padding-bottom: 0;
  }
`

const StyledCard = styled(Card)`
  display: flex;
  flex-direction: column;
  ${twoPxShadow};
  padding: 0;

  ${minWidthMedia.desktop`
    width: 100%;
    justify-content: space-between;
  `}
`

const ImageTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  margin-bottom: ${padding.small};

  ${minWidthMedia.desktop`
    flex-direction: row;
    margin-bottom: 0;
`}
`

const ImageContainer = styled(Image)`
  margin-right: ${padding.small};
  margin-bottom: ${padding.small};
`

const StyledImage = styled(Image)`
  margin-right: ${padding.small};
`

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: ${padding.base};
  ${({includeSurveyCycle}) => includeSurveyCycle && `
    padding-bottom: 0;
  `}

  ${minWidthMedia.desktop`
    flex-direction: row;
  `}
`

const SpacedStatusPillBadge = styled(StatusPillBadge)`
  display: inline-block;
  margin-bottom: ${padding.tiny};
`

const FooterWrapper = styled.div``

const ExpandContainer = styled.div`
  margin-left: ${padding.small};
  margin-bottom: ${padding.small};
`

class ScheduleCard extends Component {
    static propTypes = {
      children: PropTypes.element,
      schedule: PropTypes.object,
      formatMessage: PropTypes.func.isRequired,
      includeSurveyCycle: PropTypes.bool
    };
    static defaultProps = {
      schedule: {},
      children: null,
      includeSurveyCycle: true
    }

    render() {
      const idNamespace = id("schedule-card", this.props)
      const {schedule, formatMessage, children, includeSurveyCycle} = this.props
      const showExpander = !!schedule.lastTriggeredAt && includeSurveyCycle
      const viewSurveyCycle = formatMessage({id: "insights.homePage.cycleCard.expander.viewSurveyCycle"})
      const showLess = formatMessage({id: "insights.homePage.cycleCard.expander.showLess"})
      const customImage = isCycleCustom(schedule) ? CustomSurvey : EmployeeEngagement

      return (
        <CardWrapper id={idNamespace}>
          <StyledCard>
            <HeaderWrapper includeSurveyCycle={showExpander}>
              <ImageTitleContainer>
                <ImageContainer src={customImage} alt="" size={90} />
                <div>
                  <H3 small>{schedule.reference}</H3>
                  <SpacedStatusPillBadge validationStatus={schedule.validationStatus} />
                  <ScheduleDescription schedule={schedule} />
                </div>
              </ImageTitleContainer>
              {children && <div>
                {children}
              </div>}
            </HeaderWrapper>
            {showExpander &&
              <FooterWrapper>
                <Hr />
                <ExpandContainer>
                  <StyledImage src={ViewSurveyCycleIcon} size={29} />
                  <Expand
                    showText={viewSurveyCycle}
                    hideText={showLess}>
                    <SurveyList schedule={schedule} />
                  </Expand>
                </ExpandContainer>
              </FooterWrapper>}
          </StyledCard>
        </CardWrapper>
      )
    }
}

export default injectIntl(ScheduleCard)
